import Guid from '@/app/utils/guid'
import NodeEntity from '@/common/models/node-entitiy'

export default class ProjectStakeholderGroup extends NodeEntity {

    public projectId = Guid.empty()
    public order = 0
}
